<sd-title
  [titleThemesConfig]="brandThemesEnum.brand"
  [titleLevel]="1"
  class="is-main"
  customClass="brand--h3 is-semi-bold"
>
  {{ 'myAccountDashboard.welcome' | translate }} {{ userName }}
</sd-title>

<sd-border-wrapper [titleLevel]="2">
  <sd-title [titleLevel]="2" customClass="brand--h5 is-bold">
    {{ 'myAccountDashboard.title' | translate }}
  </sd-title>
  <p class="is-body-s c__description">{{ 'myAccountDashboard.text' | translate }}</p>
  <sd-banner [media]="{ url: urlImage }" />
</sd-border-wrapper>

<sd-border-wrapper class="c__my-orders" [titleLevel]="2">
  <sd-title [titleLevel]="2" customClass="brand--h5 is-bold">
    {{ 'order.myOrders' | translate }}
  </sd-title>
  <ul sd-list-block class="is-m">
    @for (currentOrder of currentOrders; track currentOrder) {
      <li><sd-order-information [order]="currentOrder" /></li>
    }
  </ul>
  @if (currentOrders?.length === 0) {
    <p class="is-body-s">{{ 'myAccountDashboard.noOrder' | translate }}</p>
  }
</sd-border-wrapper>

@if (isLoading) {
  <div sd-loader></div>
}
